// it is needed because of the original concept,
// which is that the basket key on us is a simple 'basket'
export const environmentSiteContext = Object.freeze({
    'us-ishares': '',
});
export const compareBasketSelector = 'ishares-compare-basket';
